/**
 * CopyStepper — the copy flow's step rail.
 *
 * Extracted when the flow's step COUNT could vary (a "Confirm what gets
 * copied" picker step used to appear for some accounts, shifting every number
 * after it). That step is gone and the flow is a fixed 3, but the rail stays
 * data-driven off copyStepLabels: the three step components each used to carry
 * their own hardcoded copy of this markup, which had already drifted into
 * three separate places to keep in sync.
 *
 * Markup is byte-equivalent to the copies it replaces: a `.step` per entry
 * (`done` for completed, `on` for current), a `.step-num` holding ✓ or the
 * 1-based index, and a `.step-line` between adjacent entries.
 */
export default function CopyStepper({ steps, current }) {
  return (
    <div className="cw-steps">
      {steps.map((label, i) => (
        <span key={label} style={{ display: 'contents' }}>
          {i > 0 && <span className="step-line" />}
          <span className={`step${i < current ? ' done' : i === current ? ' on' : ''}`}>
            <span className="step-num">{i < current ? '✓' : i + 1}</span>
            {' '}
            {label}
          </span>
        </span>
      ))}
    </div>
  );
}
